var LOAD_MORE_AMOUNT = {
    PARTIAL: 'partial',
    ALL: 'all',
};
export default LOAD_MORE_AMOUNT;
//# sourceMappingURL=loadMoreAmount.js.map